import Vue from 'vue'
// A modern alternative to CSS resets
// https://github.com/necolas/normalize.css
import VueClipBoard from 'vue-clipboard2'

// import vant
import { Popup, Form, Field, Picker, Calendar, List, Toast, Empty, Loading, DatetimePicker, Overlay, NavBar, Stepper, Uploader, Search } from 'vant'
Vue.use(Toast)
Vue.use(Picker)
Vue.use(List)
Vue.use(Calendar)
Vue.use(Form)
Vue.use(Field)
Vue.use(Popup)
Vue.use(Empty)
Vue.use(Loading)
Vue.use(DatetimePicker)
Vue.use(Overlay)
Vue.use(NavBar)
Vue.use(Stepper)
Vue.use(Uploader)
Vue.use(VueClipBoard)
Vue.use(Search)

import '@/components/Vant'
// register common components globally
import '@/components/common'
// div组件
import HButton from '@/components/button'
import HBack from '@/components/back'
import Link from '@/components/link'
import CollapseTransition from '@/components/CollapseTransition'

import './utils/auto-update'
import { initWx, initOrgWx } from '@/utils/weixin.config.js'
// Vue.use(initWx)
Vue.config.ignoredElements = ['wx-open-launch-weapp']
import App from './App.vue'
import router from './router'
import store from './store'

import onlyNumber from '@/utils/only_number'
Vue.use(onlyNumber) // 添加此行=>使用该全局指令
import './icons'
import './utils/decimal' // js浮点计算

import './utils/permission'
import './styles/index.scss'
import 'normalize.css/normalize.css'

import 'amfe-flexible'

import * as filters from '@/filters'
// 全局注册组件
Vue.component('h-button', HButton)
Vue.component('h-back', HBack)
Vue.component('h-link', Link)
Vue.component('CollapseTransition', CollapseTransition)

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

Vue.prototype.$initWx = initWx
Vue.prototype.$initOrgWx = initOrgWx
Vue.prototype.$ap = window.ap
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')

